export class MathUtil
{
    public static angleOf(p1: any,p2: any): number {
        // invert radians to get screen coordinates in degrees;
        const deltaY = (p1.y - p2.y);
        const deltaX = (p2.x - p1.x);
        const result = MathUtil.radToDeg(Math.atan2(deltaY, deltaX)); 
        return (result < 0) ? (360.0 + result) : result;
    }

    public static centerPoint(rect: any): any {
        return rect ? {x: rect.x+ (rect.width/2),y: rect.y + (rect.height/2) } : {x:0,y:0}
    }

    public static radToDeg(radians: number): number
    {
        return radians * (180/Math.PI);
    }

}